import CalculateMaxHeight from '~/directives/v-calculate-max-height.client';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('calculate-max-height', CalculateMaxHeight);
});
